var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.4987C22 16.2556 21.9034 16.0224 21.7315 15.8505C21.5596 15.6786 21.3264 15.582 21.0833 15.582H10.8333C10.5902 15.582 10.357 15.6786 10.1851 15.8505C10.0132 16.0224 9.91663 16.2556 9.91663 16.4987C9.91663 16.7418 10.0132 16.975 10.1851 17.1469C10.357 17.3188 10.5902 17.4154 10.8333 17.4154H21.0833C21.3264 17.4154 21.5596 17.3188 21.7315 17.1469C21.9034 16.975 22 16.7418 22 16.4987Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.4987C22 7.25558 21.9034 7.02243 21.7315 6.85052C21.5596 6.67861 21.3264 6.58203 21.0833 6.58203H10.8333C10.5902 6.58203 10.357 6.67861 10.1851 6.85052C10.0132 7.02243 9.91663 7.25558 9.91663 7.4987C9.91663 7.74181 10.0132 7.97497 10.1851 8.14688C10.357 8.31879 10.5902 8.41536 10.8333 8.41536H21.0833C21.3264 8.41536 21.5596 8.31879 21.7315 8.14688C21.9034 7.97497 22 7.74181 22 7.4987Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.5C3.3458 19.5 2 18.1542 2 16.5C2 14.8458 3.3458 13.5 5 13.5C6.6542 13.5 8 14.8458 8 16.5C8 18.1542 6.6542 19.5 5 19.5ZM5 14.7C4.0076 14.7 3.2 15.5076 3.2 16.5C3.2 17.4924 4.0076 18.3 5 18.3C5.9924 18.3 6.8 17.4924 6.8 16.5C6.8 15.5076 5.9924 14.7 5 14.7Z",
    fill: "#6F767E",
    stroke: "#6F767E",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5C3.3458 10.5 2 9.1542 2 7.5C2 5.8458 3.3458 4.5 5 4.5C6.6542 4.5 8 5.8458 8 7.5C8 9.1542 6.6542 10.5 5 10.5ZM5 5.7C4.0076 5.7 3.2 6.5076 3.2 7.5C3.2 8.4924 4.0076 9.3 5 9.3C5.9924 9.3 6.8 8.4924 6.8 7.5C6.8 6.5076 5.9924 5.7 5 5.7Z",
    fill: "#6F767E",
    stroke: "#6F767E",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/List_view_icon.fc14b49be9cc1b6e752dc697230a46f1.svg";
export { ForwardRef as ReactComponent };